(function (root, factory) {
  var engine = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = engine;
  }
  root.CoastFireEngine = engine;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  var DEFAULT_WITHDRAWAL_RATE = 4;

  // Solve for the level monthly deposit that carries presentValue to
  // futureValue over months periods at monthlyRate. Handles the two degenerate
  // cases the closed form cannot: no months to save over, and a zero real rate
  // (expected return equal to inflation), which previously divided by zero.
  function solveMonthlyDeposit(presentValue, futureValue, monthlyRate, months) {
    if (!(months > 0)) {
      return 0;
    }

    if (monthlyRate === 0) {
      return Math.max(0, (futureValue - presentValue) / months);
    }

    var compoundFactor = Math.pow(1 + monthlyRate, months);
    var numerator = (futureValue - presentValue * compoundFactor) * monthlyRate;
    var denominator = compoundFactor - 1;

    if (denominator === 0) {
      return Math.max(0, (futureValue - presentValue) / months);
    }

    return Math.max(0, numerator / denominator);
  }

  function calculate(input) {
    var yearsToRetirement = input.retirementAge - input.currentAge;
    var realReturn = ((1 + input.expectedReturn / 100) / (1 + input.inflationRate / 100) - 1) * 100;
    var realRate = realReturn / 100;

    // A withdrawal rate of zero (reachable through a hand-edited share link, not
    // through the form) used to make every figure on the page Infinity.
    var withdrawalRate = input.withdrawalRate > 0 ? input.withdrawalRate : DEFAULT_WITHDRAWAL_RATE;

    var calculatedFIRENumber = input.targetMethod === 'expenses'
      ? input.annualExpenses / (withdrawalRate / 100)
      : input.targetFIRENumber;

    var coastFIRENumber = calculatedFIRENumber / Math.pow(1 + realRate, yearsToRetirement);
    var projectedBalance = input.currentSavings * Math.pow(1 + realRate, yearsToRetirement);
    var isCoastFIRE = input.currentSavings >= coastFIRENumber;

    var monthlySavingsNeeded = 0;
    var yearsToCoastFIRE = 0;
    var savingsWindowMonths = 0;
    // With no years left before retirement there is no window to save over:
    // the shortfall is due immediately, and a $0/month "plan" would be a lie.
    var hasSavingsWindow = yearsToRetirement > 0;

    if (!isCoastFIRE && hasSavingsWindow) {
      var targetYears = Math.min(10, yearsToRetirement / 2);
      var targetMonths = targetYears * 12;
      savingsWindowMonths = Math.round(targetMonths);

      // The coast threshold is not a fixed number: it climbs every year you
      // spend saving, because fewer years are left for it to compound. Aim at
      // the threshold as it stands at the END of the savings window - the same
      // point the chart's target line shows at that age - rather than at
      // today's coast number, which you would arrive at years too late.
      var coastTargetAtWindowEnd = calculatedFIRENumber
        / Math.pow(1 + realRate, Math.max(0, yearsToRetirement - targetYears));

      monthlySavingsNeeded = solveMonthlyDeposit(
        input.currentSavings,
        coastTargetAtWindowEnd,
        realRate / 12,
        targetMonths
      );
      yearsToCoastFIRE = Math.ceil(targetYears);
    }

    var labels = [];
    var projectionData = [];
    var fireTargetLine = [];
    for (var i = 0; i <= yearsToRetirement; i++) {
      labels.push(input.currentAge + i);
      projectionData.push(input.currentSavings * Math.pow(1 + realRate, i));
      var remainingYears = yearsToRetirement - i;
      fireTargetLine.push(calculatedFIRENumber / Math.pow(1 + realRate, remainingYears));
    }

    return {
      yearsToRetirement: yearsToRetirement,
      realReturn: realReturn,
      calculatedFIRENumber: calculatedFIRENumber,
      coastFIRENumber: coastFIRENumber,
      projectedBalance: projectedBalance,
      isCoastFIRE: isCoastFIRE,
      yearsToCoastFIRE: yearsToCoastFIRE,
      monthlySavingsNeeded: monthlySavingsNeeded,
      savingsWindowMonths: savingsWindowMonths,
      hasSavingsWindow: hasSavingsWindow,
      effectiveWithdrawalRate: withdrawalRate,
      chart: {
        labels: labels,
        projectionData: projectionData,
        fireTargetLine: fireTargetLine
      }
    };
  }

  return {
    DEFAULT_WITHDRAWAL_RATE: DEFAULT_WITHDRAWAL_RATE,
    solveMonthlyDeposit: solveMonthlyDeposit,
    calculate: calculate
  };
});
